/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const rowErrorSchema = z.object({
  message: z.string(),
  rowIndex: z.int(),
});
